<template>
  <div class="services">
    <b-row>
      <b-col>
        <b-alert variant="success" show>Coming soon</b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Services",
};
</script>

<style scoped>
.services {
  width: 90%;
  margin-left: 20px;
  margin-top: 40px;
}
</style>
